<form>
  <div class="lv-modal-dialog">
    <div mat-dialog-title class="lv-dialog-header">
      <div [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.TITEL' | translate"
           class="lv-dialog-header-title"></div>
      <div class="lv-dialog-icon-close">
        <mat-icon [svgIcon]="'Times'" (click)="abbrechenButtonClicked()"></mat-icon>
      </div>
    </div>
    <div mat-dialog-content class="lv-dialog-content lv-modal-dialog-vorlage-changed-content">
      <div class="lv-modal-dialog-vorlage-changed-hinweis">
        <div class="lv-modal-dialog-vorlage-changed-hinweis-icon">
          <mat-icon [svgIcon]="'ExclamationMark'"></mat-icon>
        </div>
        <div
            [innerHTML]="('MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.MELDUNG' | translate) + ' ' + data.name"></div>
      </div>
      <div class="lv-modal-dialog-vorlage-changed-hinweis-bold"
           [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.SUB_MELDUNG' | translate"></div>

      <mat-radio-group class="lv-modal-dialog-vorlage-changed-radio-button-group" [name]="'options'" [(ngModel)]="selectedOption">
        <mat-radio-button class="lv-modal-dialog-vorlage-changed-radio-button" (click)="onUeberschreibenClicked()" value="ueberschreiben">
          <span [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.OPTION_UEBRSCHREIBEN' | translate"></span>
        </mat-radio-button>
        <mat-radio-button class="lv-modal-dialog-vorlage-changed-radio-button" (click)="resetShowSelectionRequiredError()"
                          value="neuSpeichern">
          <span [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.OPTION_SPEICHERN' | translate"></span>
        </mat-radio-button>
      </mat-radio-group>
      <div *ngIf="showSelectionRequiredError">
        <lv-inline-fehlermeldung
            translationKeyFehlermmeldung="ERRORS.KEINE_OPTION_GEWAEHLT_VERMITTLERPORTFOLIO_VERAENDERT_MODAL"></lv-inline-fehlermeldung>
      </div>
      <div class="lv-modal-dialog-vorlage-changed-speichern" *ngIf="selectedOption === 'neuSpeichern'">
        <lv-label-tooltip [isPflichtfeld]=true
                          [label]="('MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.OPTION_SPEICHERN_TITEL' | translate)">
        </lv-label-tooltip>
        <lv-material-form-input lvPortfolioNameValidator
                                #portfolio="ngModel"
                                [(ngModel)]="portfolioName"
                                [name]="'portfolioName'"
                                [isTouched]="portfolio.touched"
                                [isDirty]="portfolio.dirty"
                                [outerErrors]="portfolio.errors"
                                [errorPath]="'FONDS'"
                                [required]="true"
        >
        </lv-material-form-input>
      </div>
    </div>
    <div class="lv-pflichtfeld-hinweis" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
    <div mat-dialog-actions class="lv-dialog-footer" align="end">
      <button mat-raised-button color="accent" (click)="abbrechenButtonClicked()">
        <span [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.BUTTON_ABBRECHEN' | translate"></span>
      </button>
      <button mat-raised-button color="primary" (click)="speichernButtonClicked()">
        <span [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_CHANGED_MODAL.BUTTON_SPEICHERN' | translate"></span>
      </button>
    </div>
  </div>
</form>
